import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CheckboxTreeSelector from '../../../common/selection-criteria/operator-impc/CheckboxTreeSelector';

export default class TransferOperatorsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: [],
    };
  }

  onExpand = (expandedPostalOperators) => {
    this.setState({
      expanded: expandedPostalOperators,
    });
  }

  render() {
    return (
      <CheckboxTreeSelector
        title=""
        nodes={this.props.nodes}
        checked={this.props.checked}
        expanded={this.state.expanded}
        onCheck={this.props.onCheck}
        onExpand={this.onExpand}
        allSelectorDisabled
      />
    );
  }
}

TransferOperatorsContainer.propTypes = {
  nodes: PropTypes.arrayOf(PropTypes.object),
  checked: PropTypes.arrayOf(PropTypes.string),
  onCheck: PropTypes.func,
};
